"use client";

import { useEffect } from "react";
import { clientGet } from "@/service/client-api/client-api";
import { useSearchParams } from "next/navigation";

type viewKey =
  | "med"
  | "medical_supply"
  | "icd10"
  | "residency_encyclopedia"
  | "calculator"
  | "clinical_case"
  | "course"
  | "ebook"
  | "webinar"
  | "article"
  | "tutorial"
  | "fast_question"
  | "video";

async function resourceVisitLog(page: viewKey, id: string | number) {
  clientGet("resource_visit", {
    page,
    id,
  });
}

export const ResourceVisit = ({
  page,
  id,
}: {
  page: viewKey;
  id: string | number;
}) => {
  const searchParams = useSearchParams();

  useEffect(() => {
    resourceVisitLog(page, id);
  }, [searchParams]);
  return <></>;
};
